export const verifyOtpAPIUrls = {
  verifyOtp: '/auth/verify-otp',
} as const;
